import { render, staticRenderFns } from "./SOV3.vue?vue&type=template&id=68770122&scoped=true"
import script from "./SOV3.vue?vue&type=script&lang=js"
export * from "./SOV3.vue?vue&type=script&lang=js"
import style0 from "./SOV3.vue?vue&type=style&index=0&id=68770122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68770122",
  null
  
)

export default component.exports